import { makeStyles } from '@mui/styles';

export const useStylesTab = makeStyles((theme) => ({
    root: {
        whiteSpace: 'nowrap',
        backgroundColor: theme.palette.common.white,
    },
    selected: {},
    textColorInherit: {
        color: theme.palette.text.primary,
    },
}));
